import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'huge-monorepo-teltonika-select-emails-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-select-emails-modal.component.html',
  styleUrl: './teltonika-select-emails-modal.component.scss',
})
export class TeltonikaSelectEmailsModalComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  loading: boolean = false;
  emailsFormControl: FormArray<FormControl<string>> = new FormArray<FormControl<string>>([]);
  constructor(
    private formBuilder: FormBuilder,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private toastr: ToastrService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.teltonikaService.getActionRequiredEmails().subscribe({
      next: (data) => {
        if (data != null && data.body != null && data.body.Emails != null) {
          this.emailsFormControl = this.formBuilder.array<FormControl<string>>(
            data.body.Emails.map(email => 
              this.formBuilder.nonNullable.control(email || '', [Validators.email, Validators.required])
            )
          );
        }
        this.loading = false;
      },
      error: () => {
        this.toastr.error('Failed to load emails');
        this.loading = false;
      }
    });
  }

  saveEmails(): void {
    if (this.emailsFormControl.invalid) {
      this.emailsFormControl.markAllAsTouched();
      return;
    }

    const emails = this.emailsFormControl.controls.map(control => control.value);

    this.teltonikaService.updateActionRequiredEmails(emails).subscribe({
      next: () => {
        this.toastr.success('Updated Emails');
        this.location.back(); // Navigate back after success
      },
      error: () => {
        this.toastr.error('Error Updating Emails');
      }
    });
  }

  cancel(): void {
    this.location.back(); // Navigate back on cancel
  }

  addNewEmail(): void {
    this.emailsFormControl.push(this.formBuilder.nonNullable.control('', [Validators.email, Validators.required]));
  }
}
